import { Controller } from "stimulus";

export default class extends Controller {
  static PATIENT_GENRE_ID = '87700497'
  static PRACTITIONER_GENRE_ID = '954016286'
  static targets = ['marketingContact', 'marketingContactSelect']

  toggleMarketingContactField(e) {
    this.marketingContactTarget.hidden = e.target.value === this.constructor.PATIENT_GENRE_ID

    if (window.location.pathname.includes('/customers/new')) {
      if (e.target.value === this.constructor.PRACTITIONER_GENRE_ID) {
        this.marketingContactSelectTarget.value = 'true'
      }
      else {
        this.marketingContactSelectTarget.value = ''
      }
    }
  }
}
